import { render } from "./CurbsListing.vue?vue&type=template&id=7fbb10a2&ts=true"
import script from "./CurbsListing.vue?vue&type=script&lang=ts"
export * from "./CurbsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__